import { render, staticRenderFns } from "./BudgetAlertsEditComponent.vue?vue&type=template&id=5d45efa4"
import script from "./BudgetAlertsEditComponent.vue?vue&type=script&lang=js"
export * from "./BudgetAlertsEditComponent.vue?vue&type=script&lang=js"
import style0 from "./BudgetAlertsEditComponent.vue?vue&type=style&index=0&id=5d45efa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports